/**
 * Emperor Marble -- out-of-stock view, product page, SECONDARY trigger only.
 * 2026-09-03, owner directive S3.
 *
 * The PRIMARY trigger is server-side Liquid (product.available == false in
 * sections/main-product.liquid). It needs no JavaScript, so the notice is
 * indexable and survives a browser with scripting off. This file exists only
 * for the progressive second trigger:
 *
 *   assets/stone-block-grid.js dispatches `em:stone-blocks-empty` on document
 *   when the FindMyMarble API answers that the stone has zero live blocks.
 *
 * On that event the page switches to the out-of-stock view:
 *   - the pre-rendered notice ([data-em-oos-notice][hidden]) is revealed
 *   - body gets .em-oos-active, and assets/em-out-of-stock.css hides the
 *     add-to-cart box ([data-em-oos-buybox]) and the price rows
 *
 * Fails silent: no API here, no fetch here, nothing invented. If the event
 * never arrives (flag off, API down, stone not in the index) the page keeps
 * exactly the markup Liquid produced.
 */
(function () {
  'use strict';

  var ACTIVE_CLASS = 'em-oos-active';
  var applied = false;

  function apply() {
    if (applied) return;
    applied = true;

    if (document.body) document.body.classList.add(ACTIVE_CLASS);

    var notices = document.querySelectorAll('[data-em-oos-notice]');
    for (var i = 0; i < notices.length; i++) {
      notices[i].hidden = false;
    }
  }

  document.addEventListener('em:stone-blocks-empty', apply);
})();
